import { IDocumentSearchModel } from '../../interfaces/IDocument';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetMyDocumentsKey = ['get-mydocuments'];

export const useGetMyDocuments = (
    searchModel: IDocumentSearchModel,
    pageNumber: number,
    pageSize: number
) => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: [useGetMyDocumentsKey, { searchModel, pageNumber, pageSize }],
        queryFn: async () => {
            const response = await zoneApiClient.getMyDocuments(searchModel, pageNumber, pageSize);
            const sorted = response.payload?.sort((a, b) =>
                b.createdDate < a.createdDate ? -1 : 1
            );

            return sorted;
        },
        staleTime: 0,
        cacheTime: 0,
        keepPreviousData: true,
    });
};

export const useGetMyDocumentsCount = (searchModel: IDocumentSearchModel) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-mydocuments-count', { searchModel }],
        queryFn: async () => {
            const response = await zoneApiClient.getMyDocumentsCount(searchModel);

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve my documents count.');
            }

            return response.payload;
        },
    });
};
